import { temAcesso } from '@/shared/auth/temAcesso'

const Relatorios = () => import('./Relatorios.vue')
const ConsumoQtdPorSubItem = () =>
    import('./ConsumoQtdPorSubItem.vue')
const ComprometimentosSemRegistroPagamento = () =>
    import('./ComprometimentosSemRegistroPagamento.vue')
const RelacaoNotasFiscais = () =>
    import('./RelacaoNotasFiscais.vue')
const ComprometimentosPorContrato = () =>
    import('./ComprometimentosPorContrato.vue')
const ContratosPorGestor = () =>
    import('./ContratosPorGestor.vue')
const ValoresPagosPorContratos = () =>
    import('./ValoresPagosPorContratos.vue')

export default {
    path: '/gescon/relatorioscontratos',
    name: 'Gescon_Relatorios_Contratos',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-CONT-REL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'consumoqtdporsubitem',
            name: 'Gescon_Relatorios_Contratos_ConsumoQtdPorSubItem',
            component: ConsumoQtdPorSubItem,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-CONT-REL-01')) {
                    next()
                }
            }
        },
        {
            path: 'comprometimentossemregistropagamento',
            name: 'Gescon_Relatorios_Contratos_ComprometimentosSemRegistroPagamento',
            component: ComprometimentosSemRegistroPagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-CONT-REL-01')) {
                    next()
                }
            }
        },
        {
            path: 'relacaonotasfiscais',
            name: 'Gescon_Relatorios_Contratos_RelacaoNotasFiscais',
            component: RelacaoNotasFiscais,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-CONT-REL-02')) {
                    next()
                }
            }
        },
        {
            path: 'comprometimentosporcontrato',
            name: 'Gescon_Relatorios_Contratos_ComprometimentosPorContrato',
            component: ComprometimentosPorContrato,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-CONT-REL-03')) {
                    next()
                }
            }
        },
        {
            path: 'contratosporgestor',
            name: 'Gescon_Relatorios_Contratos_ContratosPorGestor',
            component: ContratosPorGestor,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-CONT-REL-04')) {
                    next()
                }
            }
        },
        {
            path: 'valorespagosporcontratos',
            name: 'Gescon_Relatorios_Contratos_ValoresPagosPorContratos',
            component: ValoresPagosPorContratos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-CONT-REL-05')) {
                    next()
                }
            }
        },
    ]
}
